import type { UncastObject } from '@epilot/journey-logic-commons/src/types/next'
import { LANGUAGE } from '@epilot/journey-logic-commons/src/types/next'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useEffect } from 'react'

import { instance18n } from '../locales/i18n'
import { selectJourneyLanguage } from '../store/selectors/config'

import { useAppStoreSelector } from './useAppStoreSelector'

const ENTITY_LOCALE_NAMESPACE = 'entity'

export const useLanguage = (override?: LANGUAGE) => {
  const journeyLanguage = useAppStoreSelector(selectJourneyLanguage)
  const language = override ?? journeyLanguage ?? LANGUAGE.DE

  const entityLocaleQuery = useQuery({
    queryKey: ['entity-locale', language],
    queryFn: async ({ signal }) => {
      const response = await axios.get<UncastObject>(
        `https://portal.epilot.cloud/locales/${language}/${ENTITY_LOCALE_NAMESPACE}.json`,
        { signal }
      )

      return {
        language,
        locale: response.data
      }
    },
    staleTime: Infinity
  })

  // add the translations to the i18next instance
  useEffect(() => {
    if (entityLocaleQuery?.data) {
      instance18n.addResourceBundle(
        entityLocaleQuery.data.language,
        ENTITY_LOCALE_NAMESPACE,
        entityLocaleQuery.data.locale,
        true,
        true
      )
    }
  }, [entityLocaleQuery?.data])

  // syncs the language of i18next instance
  useEffect(() => {
    instance18n.changeLanguage(language)
    // updates the html tag
    document.documentElement.lang = language
  }, [language])
}
